import { VENDOR_FAILURE, VENDOR_SUCCESS } from "redux/constants";
import { onSuccess, onFailure } from "redux/reducers/common";

const initStat = { data: [], error: false, errorData: "", isLoading: true };

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = initStat, action) => {
    switch (action.type) {
        case VENDOR_SUCCESS:
            return onSuccess(state, action);
        case VENDOR_FAILURE:
            return onFailure(state, action);
        default:
            return { ...state };
    }
};
